import type { ProductFormSchema } from '../hooks/useProductForm'

import type { Shop } from '~/common/schemas/shop'
import { channelProductFieldInfo, channelProductFieldInfoForMallShops } from '~/constants'

// default field info for non-support product listing channels
export const DefaultChannelFieldInfo = {
    name: { minLength: 0, maxLength: Number.MAX_VALUE },
    description: { minLength: 0, maxLength: Number.MAX_VALUE },
    shortDescription: { minLength: 0, maxLength: Number.MAX_VALUE },
    allowImageOnlyDescription: true,
}

export function getFieldValidations(channelProducts: ProductFormSchema['channel_products']) {
    // TODO: Make channel product field info a dynamic value fetched from the API?

    const fieldInfos = channelProducts
        .map((cp) => {
            return cp.shouldCreateChannelProduct || !isNaN(cp.id)
                ? getFieldInfoByShop(cp.shop)
                : null
        })
        .filter(Boolean) as Array<ReturnType<typeof getFieldInfoByShop>>

    return fieldInfos.reduce(
        (acc, currentChannelInfo) => {
            return {
                name: {
                    minLength: Math.max(acc.name.minLength, currentChannelInfo.name.minLength),
                    maxLength: acc.name.maxLength
                        ? Math.min(acc.name.maxLength, currentChannelInfo.name.maxLength)
                        : currentChannelInfo.name.maxLength,
                },
                description: {
                    minLength: Math.max(
                        acc.description.minLength,
                        currentChannelInfo.description.minLength
                    ),
                    maxLength: acc.description.maxLength
                        ? Math.min(
                              acc.description.maxLength,
                              currentChannelInfo.description.maxLength
                          )
                        : currentChannelInfo.description.maxLength,
                },
                shortDescription: {
                    minLength: Math.max(
                        acc.shortDescription.minLength,
                        currentChannelInfo.shortDescription.minLength
                    ),
                    maxLength: acc.shortDescription.maxLength
                        ? Math.min(
                              acc.shortDescription.maxLength,
                              currentChannelInfo.shortDescription.maxLength
                          )
                        : currentChannelInfo.shortDescription.maxLength,
                },
                allowImageOnlyDescription: currentChannelInfo.allowImageOnlyDescription && acc.allowImageOnlyDescription
            }
        },
        DefaultChannelFieldInfo
    )
}

export function getFieldInfoByShop(shop: Shop) {
    const fieldInfoByChannel = shop.extra_info?.is_mall_shop
        ? channelProductFieldInfoForMallShops
        : channelProductFieldInfo
    return fieldInfoByChannel[shop.channel.id as keyof typeof fieldInfoByChannel]
}
